/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     接入点 API
  | @Version:   2020-01-03  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const generalApiHost = process.env.VUE_APP_GENERAL_API_HOST;

export function apHomeStatApi(params) {
  return request({
    url: '?c=ap&a=home&do=stat',
    method: 'get',
    params
  })
}

export function apHomeStatusApi(params) {
  return request({
    url: '?c=ap&a=home&do=status',
    method: 'get',
    params
  })
}

export function apApListApi(params) {
  return request({
    url: generalApiHost + '/ap/list',
    method: 'get',
    params
  })
}

export function apApGetApi(params) {
  return request({
    url: '?c=ap&a=ap&do=get',
    method: 'get',
    params
  })
}

export function apGetApi(params) {
  return request({
    url:generalApiHost + '/ap/get',
    method: 'get',
    params
  })
}

export function apGetFlowApi(params) {
  return request({
    url:generalApiHost + '/ap/getFlowUse',
    method: 'get',
    params
  })
}

export function apGetFlowCurveApi(params) {
  return request({
    url:generalApiHost + '/ap/getFlowUseCurve',
    method: 'get',
    params
  })
}

export function apGetModelApi(params) {
  return request({
    url:generalApiHost + '/ap/super/getModel',
    method: 'get',
    params
  })
}

export function apApFlowApi(params) {
  return request({
    url: '?c=ap&a=ap&do=flow',
    method: 'get',
    params
  })
}

export function apRecycleListApi(params) {
  return request({
    url: '?c=ap&a=recycle&do=list',
    method: 'get',
    params
  })
}

export function apDeleteApi(data) {
  return request({
    url: generalApiHost + '/ap/recycle',
    method: 'post',
    data
  })
}

export function apRecycleStatApi() {
  return request({
    url: '?c=ap&a=recycle&do=stat',
    method: 'get'
  })
}


export function apDtusimStatApi(params) {
  return request({
    url: generalApiHost + '/ap/abnormal/stat',
    method: 'get',
    params
  })
}

export function apAbnormalApi(params) {
  return request({
    url: generalApiHost + '/ap/abnormal/list',
    method: 'get',
    params
  })
}

export function analysisTemplateApi(data) {
  return request({
    url: generalApiHost + '/dtu/record/analysisTemplate',
    method: 'post',
    data
  })
}

export function apExportApi(data) {
  return request({
    url: generalApiHost + "/ap/export",
    method: "post",
    data,
    responseType: "blob"
  });
}

export function getQuotaApi(params) {
  return request({
    url: generalApiHost + '/god/quota/getQuota',
    method: 'get',
    params
  })
}

export function calculatePayAmount(data) {
  return request({
    url: generalApiHost + '/god/quota/calculatePayAmount',
    method: 'post',
    data
  })
}

export function createQuotaOrder(data) {
  return request({
    url: generalApiHost + '/god/quota/createQuotaOrder',
    method: 'post',
    data
  })
}

export function sendFreeTrial(data) {
  return request({
    url: generalApiHost + '/god/quota/sendFreeTrial',
    method: 'post',
    data
  })
}

export function calculateRemainApi(params) {
  return request({
    url: generalApiHost + '/god/quota/calculateRemain',
    method: 'get',
    params
  })
}

export function randomSimidApi(params) {
  return request({
    url: generalApiHost + '/ap/randomSimid',
    method: 'get',
    params
  })
}

export function bathRandomSimidApi(params) {
  return request({
    url: generalApiHost + '/ap/bathRandomSimid',
    method: 'get',
    params
  })
}

export function apCreateApi(data) {
  return request({
    url: generalApiHost + '/ap/create',
    method: 'post',
    data
  })
}

